import { FiltersMap, MultiCollectionSupport } from '@wix/bex-core';
import { useWixPatternsContainer } from '@wix/bex-core/react';
import { useToolbarCollectionEmptyStateTexts } from '../../hooks/useToolbarCollectionEmptyStateTexts';
import { EmptyStateBase } from './EmptyStateBase';
import React from 'react';
import { ToolbarCollectionEmptyStateBaseProps } from './ToolbarCollectionEmptyStateBase';
import { NewItemButton } from './NewItemButton';

export interface ToolbarCollectionEmptyStateBasePrivateProps<
  F extends FiltersMap,
> extends ToolbarCollectionEmptyStateBaseProps {
  state: MultiCollectionSupport<F>;
}

export function ToolbarCollectionEmptyStateBasePrivate<F extends FiltersMap>(
  props: ToolbarCollectionEmptyStateBasePrivateProps<F>,
) {
  const { onAddNewClick, addNewText, disableDefaultCta, state } = props;
  const { translate: t } = useWixPatternsContainer();
  const { title, subtitle, cta } = useToolbarCollectionEmptyStateTexts({
    state,
    disableDefaultCta,
    title: t('cairo.emptyState.additem.title'),
    subtitle: t('cairo.emptyState.additem.text'),
    cta: onAddNewClick ? (
      <NewItemButton onAddNewClick={onAddNewClick} addNewText={addNewText} />
    ) : undefined,
  });

  return (
    <EmptyStateBase title={title} subtitle={subtitle} cta={cta} {...props} />
  );
}
